<app-chart-grid
    [disableFilter]="true"
    [loadFilter]="false"
    [filters]="filters"
    [hideFilterItems]="hideFilterItems"
    [routeParameters]="routeParameters"
    [includeMerged]="true"
    [moreActions]="actions"
  (selectionChange)="onMemberChartsGridSelectionChange($event)"
  >
</app-chart-grid>
<app-attach-chart-modal *ngIf="showAttachChartToChaseModal" [chartData]="chartDetail" (onCancel)="onCancel($event)"></app-attach-chart-modal>
